<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">
          Referencia personal
        </h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="firstName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Nombres</label>
                <md-input v-model="model.refPersonalName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refPersonalLastName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Apellidos</label>
                <md-input v-model="model.refPersonalLastName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refPersonalCellphone"
              rules="required|max_value:3999999999|min_value:3000000000"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Celular</label>
                <md-input v-model="model.refPersonalCellphone" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_REF_P_RELATION }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainRefPRelation"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Relación</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainRefPRelation"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
        </div>
        <h5 class="info-text">
          Referencia familiar
        </h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamiliarName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Nombres</label>
                <md-input v-model="model.refFamiliarName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamiliarLastName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Apellidos</label>
                <md-input v-model="model.refFamiliarLastName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamililarCellphone"
              rules="required|max_value:3999999999|min_value:3000000000"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Celular</label>
                <md-input v-model="model.refFamililarCellphone" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_REF_F_RELATION }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainRefFRelation"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Relación</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainRefFRelation"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
        </div>
        <h5 class="info-text">
          Preguntas finales
        </h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_BANKS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainHowKnowCap"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>monetization_on</md-icon>
                    <label for="select">¿Qué banco planeas usar?</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainBank"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <md-icon>card_membership</md-icon>
              <label>Número de Cuenta</label>
              <md-input v-model="profileBank.bankAccountNumber" type="text">
              </md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="timeLiving"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>assignment_turned_in</md-icon>
                <label>Tipo de cuenta</label>
                <md-select v-model="profileBank.bankAccountType" name="select">
                  <md-option :value="null" disabled>Seleccionar tipo</md-option>
                  <md-option value="Ahorros">Ahorros</md-option>
                  <md-option value="Corriente">Corriente</md-option>
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_HOW_FIND_US }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainHowKnowCap"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>feedback</md-icon>
                    <label for="select">¿Cómo conociste CAPITAL77?</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainHowKnowCap"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, max, min } from "vee-validate/dist/rules";
import Constants from "../../../constants";
import gql from "graphql-tag";

extend("required", required);
extend("max", max);
extend("min", min);

export default {
  components: {
    SlideYDownTransition
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query getDomain($fieldName: String!) {
            getDomain(fieldName: $fieldName) {
              id: domId
              name: fieldName
              value: fieldValue
            }
          }
        `,
        variables: {
          fieldName: Constants.DOMAIN_PLAN_TYPE
        }
      })
      .then(data => {
        this.planTypes = data.data.getDomain;
      });
  },
  data() {
    return {
      Constants: Constants,
      model: {
        refPersonalName: null,
        refPersonalLastName: null,
        refPersonalCellphone: null,
        refFamiliarName: null,
        refFamiliarLastName: null,
        refFamililarCellphone: null
      },
      capDomainBank: null,
      capDomainRefFRelation: null,
      capDomainRefPRelation: null,
      capDomainHowKnowCap: null,
      profileBank: {
        bankAccountNumber: null,
        bankAccountType: null
      }
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit(
          "on-validated",
          res,
          this.model,
          this.capDomainRefFRelation,
          this.capDomainRefPRelation,
          this.capDomainHowKnowCap,
          this.capDomainBank,
          this.profileBank
        );
        return res;
      });
    }
  }
};
</script>
<style></style>
